import { RouteComponent, RouteRecordRaw } from 'vue-router';
import { REPORTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';

export const reportRoutes: RouteRecordRaw[] = [
  {
    path: '/mga',
    children: [
      {
        name: REPORTS_SECTIONS_ROUTES.MGA,
        path: REPORTS_SECTIONS_ROUTES.MGA,
        component: async (): Promise<RouteComponent> => await import('@/layouts/mga-page/mga-page.vue'),
      },
      {
        name: REPORTS_SECTIONS_ROUTES.MGA_REAL_MONEY_BALANCE,
        path: REPORTS_SECTIONS_ROUTES.MGA_REAL_MONEY_BALANCE,
        component: async (): Promise<RouteComponent> =>
          await import('@/layouts/mga-real-money-balance-page/mga-real-money-balance-page.vue'),
      },
    ],
  },
];
